
import CardTable from "./Table";
import * as hooks from "./hooks";

/**
 * 兼容旧版本创建表格方法
 * @param {string} mainCode 表格主区域编码
 * @param {object} config 表格业务配置
 */

/**
 * @namespace CardTable
 */

export default function CardTableOutput() {
    this.register("cardTable"); // 生成 this.cardTableDataSource[id]
    return {
        ...Object.entries(hooks).reduce((wrappedHooks, [name, hook]) => {
            wrappedHooks[name] = (...rest) => {
                console.log('CardTable调用：', name, '参数为：', ...rest);
                try {
                    // console.time(`${name}耗时`);
                    let res = hook.call(this, ...rest);
                    // console.timeEnd(`${name}耗时`);
                    return res;
                } catch(e) {
                    console.error(e);
                }
            };
            return wrappedHooks;
        }, {}),
    };
}

CardTableOutput.component = CardTable;
CardTableOutput.displayName = "CardTable";
CardTableOutput.unfinished = ["cardTableUnFinishedApi"];

/**
 * 初始化CardTable的所有store，以及关联关系
 *  - 把业务use的都创建出来
 *  - 业务创建过了，用业务的，否则自己创建
 */
CardTableOutput.init = function (meta) {
    let { cardTableDataSource = {} } = this;

    // 遍历已有的cardTableDataSource（需要业务组use）
    // 以这些为入口，建立关联关系，并创建所有的store
    // 以id为维度创建relation，防止冲突
    let relation = Object.keys(cardTableDataSource).reduce((relation, mainId) => {
        relation[mainId] = hooks.createRelation.call(this, meta, mainId);
        return relation;
    }, {});

    console.log(
        '———————— meta ————————', meta, 
        '\n———————— tableRelation ———————— ', relation,
        // '\n———————— ctx ———————— ', this,
    );

    this.tableRelation = relation;
};
